import { FileOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { Paper } from '@components/Paper';

export const Container = styled(Paper)`
  border-radius: 12px;
  overflow: hidden;

  .toolbar-wrapper {
    background-color: red;
    padding: 0px 24px;
    color: #fff;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 100px;
  }

  .toolbar-wrapper .anticon {
    padding: 12px;
    cursor: pointer;
  }

  .toolbar-wrapper .anticon[disabled] {
    cursor: not-allowed;
    opacity: 0.3;
  }

  .toolbar-wrapper .anticon:hover {
    opacity: 0.3;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-inline: 16px;
  padding-block: 14px;

  & + & {
    border-top: 1px solid #f0f0f0;
  }
`;

export const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #e6f4ff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconLink = styled.a`
  display: inline-flex;
`;

export const FileIcon = styled(FileOutlined)`
  font-size: 18px;
`;

export const PreviewContainer = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;

  .ant-image,
  .ant-image-img {
    width: 40px;
    height: 40px;
  }

  .ant-image-img {
    border-radius: 10px;
    object-fit: cover;
  }
`;
